/**
 * i18next Configuration
 *
 * This file initializes i18next for internationalization support
 * with 8 languages (en, de, fr, it, uk, ja, zh, ko) and 19 namespaces
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
// English
import commonEN from './translations/en/common.json'
import toastsEN from './translations/en/toasts.json'
import formsEN from './translations/en/forms.json'
import errorsEN from './translations/en/errors.json'
import authEN from './translations/en/auth.json'
import paymentsEN from './translations/en/payments.json'
import patientsEN from './translations/en/patients.json'
import spirometryEN from './translations/en/spirometry.json'
import respirologyEN from './translations/en/respirology.json'
import adminEN from './translations/en/admin.json'
import settingsEN from './translations/en/settings.json'
import menubarEN from './translations/en/menubar.json'
import diagnosticsEN from './translations/en/diagnostics.json'
import reportsEN from './translations/en/reports.json'
import segmentationEN from './translations/en/segmentation.json'
import cprEN from './translations/en/cpr.json'
import tutorialsEN from './translations/en/tutorials.json'
import onboardingEN from './translations/en/onboarding.json'
import costsEN from './translations/en/costs.json'

// German
import commonDE from './translations/de/common.json'
import toastsDE from './translations/de/toasts.json'
import formsDE from './translations/de/forms.json'
import errorsDE from './translations/de/errors.json'
import authDE from './translations/de/auth.json'
import paymentsDE from './translations/de/payments.json'
import patientsDE from './translations/de/patients.json'
import spirometryDE from './translations/de/spirometry.json'
import respirologyDE from './translations/de/respirology.json'
import adminDE from './translations/de/admin.json'
import settingsDE from './translations/de/settings.json'
import menubarDE from './translations/de/menubar.json'
import diagnosticsDE from './translations/de/diagnostics.json'
import reportsDE from './translations/de/reports.json'
import segmentationDE from './translations/de/segmentation.json'
import cprDE from './translations/de/cpr.json'
import tutorialsDE from './translations/de/tutorials.json'
import onboardingDE from './translations/de/onboarding.json'
import costsDE from './translations/de/costs.json'

// French
import commonFR from './translations/fr/common.json'
import toastsFR from './translations/fr/toasts.json'
import formsFR from './translations/fr/forms.json'
import errorsFR from './translations/fr/errors.json'
import authFR from './translations/fr/auth.json'
import paymentsFR from './translations/fr/payments.json'
import patientsFR from './translations/fr/patients.json'
import spirometryFR from './translations/fr/spirometry.json'
import respirologyFR from './translations/fr/respirology.json'
import adminFR from './translations/fr/admin.json'
import settingsFR from './translations/fr/settings.json'
import menubarFR from './translations/fr/menubar.json'
import diagnosticsFR from './translations/fr/diagnostics.json'
import reportsFR from './translations/fr/reports.json'
import segmentationFR from './translations/fr/segmentation.json'
import cprFR from './translations/fr/cpr.json'
import tutorialsFR from './translations/fr/tutorials.json'
import onboardingFR from './translations/fr/onboarding.json'
import costsFR from './translations/fr/costs.json'

// Italian
import commonIT from './translations/it/common.json'
import toastsIT from './translations/it/toasts.json'
import formsIT from './translations/it/forms.json'
import errorsIT from './translations/it/errors.json'
import authIT from './translations/it/auth.json'
import paymentsIT from './translations/it/payments.json'
import patientsIT from './translations/it/patients.json'
import spirometryIT from './translations/it/spirometry.json'
import respirologyIT from './translations/it/respirology.json'
import adminIT from './translations/it/admin.json'
import settingsIT from './translations/it/settings.json'
import menubarIT from './translations/it/menubar.json'
import diagnosticsIT from './translations/it/diagnostics.json'
import reportsIT from './translations/it/reports.json'
import segmentationIT from './translations/it/segmentation.json'
import cprIT from './translations/it/cpr.json'
import tutorialsIT from './translations/it/tutorials.json'
import onboardingIT from './translations/it/onboarding.json'
import costsIT from './translations/it/costs.json'

// Japanese
import commonJA from './translations/ja/common.json'
import toastsJA from './translations/ja/toasts.json'
import formsJA from './translations/ja/forms.json'
import errorsJA from './translations/ja/errors.json'
import authJA from './translations/ja/auth.json'
import paymentsJA from './translations/ja/payments.json'
import patientsJA from './translations/ja/patients.json'
import spirometryJA from './translations/ja/spirometry.json'
import respirologyJA from './translations/ja/respirology.json'
import adminJA from './translations/ja/admin.json'
import settingsJA from './translations/ja/settings.json'
import menubarJA from './translations/ja/menubar.json'
import diagnosticsJA from './translations/ja/diagnostics.json'
import reportsJA from './translations/ja/reports.json'
import segmentationJA from './translations/ja/segmentation.json'
import cprJA from './translations/ja/cpr.json'
import tutorialsJA from './translations/ja/tutorials.json'
import onboardingJA from './translations/ja/onboarding.json'
import costsJA from './translations/ja/costs.json'

// Chinese (Simplified)
import commonZH from './translations/zh/common.json'
import toastsZH from './translations/zh/toasts.json'
import formsZH from './translations/zh/forms.json'
import errorsZH from './translations/zh/errors.json'
import authZH from './translations/zh/auth.json'
import paymentsZH from './translations/zh/payments.json'
import patientsZH from './translations/zh/patients.json'
import spirometryZH from './translations/zh/spirometry.json'
import respirologyZH from './translations/zh/respirology.json'
import adminZH from './translations/zh/admin.json'
import settingsZH from './translations/zh/settings.json'
import menubarZH from './translations/zh/menubar.json'
import diagnosticsZH from './translations/zh/diagnostics.json'
import reportsZH from './translations/zh/reports.json'
import segmentationZH from './translations/zh/segmentation.json'
import cprZH from './translations/zh/cpr.json'
import tutorialsZH from './translations/zh/tutorials.json'
import onboardingZH from './translations/zh/onboarding.json'
import costsZH from './translations/zh/costs.json'

// Ukrainian
import commonUK from './translations/uk/common.json'
import toastsUK from './translations/uk/toasts.json'
import formsUK from './translations/uk/forms.json'
import errorsUK from './translations/uk/errors.json'
import authUK from './translations/uk/auth.json'
import paymentsUK from './translations/uk/payments.json'
import patientsUK from './translations/uk/patients.json'
import spirometryUK from './translations/uk/spirometry.json'
import respirologyUK from './translations/uk/respirology.json'
import adminUK from './translations/uk/admin.json'
import settingsUK from './translations/uk/settings.json'
import menubarUK from './translations/uk/menubar.json'
import diagnosticsUK from './translations/uk/diagnostics.json'
import reportsUK from './translations/uk/reports.json'
import segmentationUK from './translations/uk/segmentation.json'
import cprUK from './translations/uk/cpr.json'
import tutorialsUK from './translations/uk/tutorials.json'
import onboardingUK from './translations/uk/onboarding.json'
import costsUK from './translations/uk/costs.json'

// Korean
import commonKO from './translations/ko/common.json'
import toastsKO from './translations/ko/toasts.json'
import formsKO from './translations/ko/forms.json'
import errorsKO from './translations/ko/errors.json'
import authKO from './translations/ko/auth.json'
import paymentsKO from './translations/ko/payments.json'
import patientsKO from './translations/ko/patients.json'
import spirometryKO from './translations/ko/spirometry.json'
import respirologyKO from './translations/ko/respirology.json'
import adminKO from './translations/ko/admin.json'
import settingsKO from './translations/ko/settings.json'
import menubarKO from './translations/ko/menubar.json'
import diagnosticsKO from './translations/ko/diagnostics.json'
import reportsKO from './translations/ko/reports.json'
import segmentationKO from './translations/ko/segmentation.json'
import cprKO from './translations/ko/cpr.json'
import tutorialsKO from './translations/ko/tutorials.json'
import onboardingKO from './translations/ko/onboarding.json'
import costsKO from './translations/ko/costs.json'

/**
 * Translation resources organized by language and namespace
 */
const resources = {
  en: {
    common: commonEN,
    toasts: toastsEN,
    forms: formsEN,
    errors: errorsEN,
    auth: authEN,
    payments: paymentsEN,
    patients: patientsEN,
    spirometry: spirometryEN,
    respirology: respirologyEN,
    admin: adminEN,
    settings: settingsEN,
    menubar: menubarEN,
    diagnostics: diagnosticsEN,
    reports: reportsEN,
    segmentation: segmentationEN,
    cpr: cprEN,
    tutorials: tutorialsEN,
    onboarding: onboardingEN,
    costs: costsEN,
  },
  de: {
    common: commonDE,
    toasts: toastsDE,
    forms: formsDE,
    errors: errorsDE,
    auth: authDE,
    payments: paymentsDE,
    patients: patientsDE,
    spirometry: spirometryDE,
    respirology: respirologyDE,
    admin: adminDE,
    settings: settingsDE,
    menubar: menubarDE,
    diagnostics: diagnosticsDE,
    reports: reportsDE,
    segmentation: segmentationDE,
    cpr: cprDE,
    tutorials: tutorialsDE,
    onboarding: onboardingDE,
    costs: costsDE,
  },
  fr: {
    common: commonFR,
    toasts: toastsFR,
    forms: formsFR,
    errors: errorsFR,
    auth: authFR,
    payments: paymentsFR,
    patients: patientsFR,
    spirometry: spirometryFR,
    respirology: respirologyFR,
    admin: adminFR,
    settings: settingsFR,
    menubar: menubarFR,
    diagnostics: diagnosticsFR,
    reports: reportsFR,
    segmentation: segmentationFR,
    cpr: cprFR,
    tutorials: tutorialsFR,
    onboarding: onboardingFR,
    costs: costsFR,
  },
  it: {
    common: commonIT,
    toasts: toastsIT,
    forms: formsIT,
    errors: errorsIT,
    auth: authIT,
    payments: paymentsIT,
    patients: patientsIT,
    spirometry: spirometryIT,
    respirology: respirologyIT,
    admin: adminIT,
    settings: settingsIT,
    menubar: menubarIT,
    diagnostics: diagnosticsIT,
    reports: reportsIT,
    segmentation: segmentationIT,
    cpr: cprIT,
    tutorials: tutorialsIT,
    onboarding: onboardingIT,
    costs: costsIT,
  },
  ja: {
    common: commonJA,
    toasts: toastsJA,
    forms: formsJA,
    errors: errorsJA,
    auth: authJA,
    payments: paymentsJA,
    patients: patientsJA,
    spirometry: spirometryJA,
    respirology: respirologyJA,
    admin: adminJA,
    settings: settingsJA,
    menubar: menubarJA,
    diagnostics: diagnosticsJA,
    reports: reportsJA,
    segmentation: segmentationJA,
    cpr: cprJA,
    tutorials: tutorialsJA,
    onboarding: onboardingJA,
    costs: costsJA,
  },
  zh: {
    common: commonZH,
    toasts: toastsZH,
    forms: formsZH,
    errors: errorsZH,
    auth: authZH,
    payments: paymentsZH,
    patients: patientsZH,
    spirometry: spirometryZH,
    respirology: respirologyZH,
    admin: adminZH,
    settings: settingsZH,
    menubar: menubarZH,
    diagnostics: diagnosticsZH,
    reports: reportsZH,
    segmentation: segmentationZH,
    cpr: cprZH,
    tutorials: tutorialsZH,
    onboarding: onboardingZH,
    costs: costsZH,
  },
  uk: {
    common: commonUK,
    toasts: toastsUK,
    forms: formsUK,
    errors: errorsUK,
    auth: authUK,
    payments: paymentsUK,
    patients: patientsUK,
    spirometry: spirometryUK,
    respirology: respirologyUK,
    admin: adminUK,
    settings: settingsUK,
    menubar: menubarUK,
    diagnostics: diagnosticsUK,
    reports: reportsUK,
    segmentation: segmentationUK,
    cpr: cprUK,
    tutorials: tutorialsUK,
    onboarding: onboardingUK,
    costs: costsUK,
  },
  ko: {
    common: commonKO,
    toasts: toastsKO,
    forms: formsKO,
    errors: errorsKO,
    auth: authKO,
    payments: paymentsKO,
    patients: patientsKO,
    spirometry: spirometryKO,
    respirology: respirologyKO,
    admin: adminKO,
    settings: settingsKO,
    menubar: menubarKO,
    diagnostics: diagnosticsKO,
    reports: reportsKO,
    segmentation: segmentationKO,
    cpr: cprKO,
    tutorials: tutorialsKO,
    onboarding: onboardingKO,
    costs: costsKO,
  },
}

/**
 * Initialize i18next
 */
i18n
  // Detect user language
  // Priority: localStorage > navigator language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Fallback language if translation not found
    fallbackLng: 'en',

    // Default namespace
    defaultNS: 'common',

    // Available namespaces
    ns: [
      'common',
      'toasts',
      'forms',
      'errors',
      'auth',
      'payments',
      'patients',
      'spirometry',
      'respirology',
      'admin',
      'settings',
      'menubar',
      'diagnostics',
      'reports',
      'segmentation',
      'cpr',
      'tutorials',
      'onboarding',
      'costs',
    ],

    // Debug mode (only in development)
    debug: process.env.NODE_ENV === 'development',

    // Interpolation options
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },

    // Language detection options
    detection: {
      // Detection order
      order: ['localStorage', 'navigator'],

      // Cache user language preference
      caches: ['localStorage'],

      // LocalStorage key
      lookupLocalStorage: 'language',
    },

    // Return empty string if translation not found
    // (instead of showing the key)
    returnEmptyString: false,

    // Show key if translation missing (helps debugging)
    saveMissing: false,

    // Allow keys to be phrases having `:`, `.`
    nsSeparator: ':',
    keySeparator: '.',

    // React options
    react: {
      // Wait for translations to be loaded before rendering
      useSuspense: false,
    },
  })
  .then(() => {
    console.log('✅ i18next initialized successfully')
    console.log('   Language:', i18n.language)
    console.log('   Resources:', Object.keys(resources))
    console.log('   Loaded namespaces:', i18n.options.ns)

    // Test a translation (commented out due to TypeScript signature issues)
    // const testKey = 'toasts:success.saved'
    // const translation = i18n.t(testKey)
    // console.log(`   Test translation (${testKey}):`, translation)
  })
  .catch((error) => {
    console.error('❌ i18next initialization failed:', error)
  })

// Expose i18next on window for debugging
if (typeof window !== 'undefined') {
  ;(window as any).i18next = i18n
  console.log('🔧 i18next exposed on window for debugging')
}

export default i18n
